var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[(_vm.hasAlert)?_c('alert',{attrs:{"id":"popup-error","type":"warning","dismissible":""},on:{"dismissed":function($event){_vm.hasAlert = false}}},_vm._l((_vm.content),function(item){return _c('ul',{staticClass:"property"},[_c('li',{staticClass:"item"},[_vm._v(_vm._s(item))])])})):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c491114","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Popups.vue
// module id = 752
// module chunks = 0